export default "__VITE_ASSET__0asuhvVC__"